// 英文版《隐私政策》——内联 HTML。
// 用 srcDoc 直接注入 iframe，避免依赖 public/ 静态文件（真机/部署环境下新文件未及时下发时会出现 404 → SPA 兜底变成登录页）。
export default `      
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>ODance Privacy Policy</title>
    <style>
        /* Global Reset & Font */
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
            background-color: #f8f9fc;
            color: #1e293b;
            line-height: 1.7;
            padding: 24px 16px;
        }

        .container {
            max-width: 820px;
            margin: 0 auto;
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
            padding: 40px 36px;
        }

        /* Typography */
        h1 {
            font-size: 28px;
            font-weight: 700;
            letter-spacing: -0.3px;
            color: #0f172a;
            margin-bottom: 8px;
            text-align: center;
        }

        .subhead {
            text-align: center;
            font-size: 15px;
            color: #64748b;
            border-bottom: 1px solid #e9edf2;
            padding-bottom: 20px;
            margin-bottom: 28px;
        }

        .subhead span {
            display: inline-block;
            margin: 0 12px;
        }

        h2 {
            font-size: 20px;
            font-weight: 600;
            color: #0f172a;
            margin-top: 32px;
            margin-bottom: 14px;
            padding-bottom: 6px;
            border-bottom: 2px solid #eef2f6;
        }

        h3 {
            font-size: 17px;
            font-weight: 600;
            color: #1e293b;
            margin-top: 20px;
            margin-bottom: 8px;
        }

        p {
            margin-bottom: 14px;
            font-size: 15px;
            color: #334155;
        }

        /* Lists */
        ul,
        ol {
            padding-left: 24px;
            margin-bottom: 16px;
        }

        li {
            margin-bottom: 8px;
            font-size: 15px;
            color: #334155;
        }

        .list-dense li {
            margin-bottom: 4px;
        }

        /* Highlight Box */
        .highlight-box {
            background-color: #f1f5f9;
            border-left: 4px solid #3b82f6;
            padding: 16px 20px;
            border-radius: 8px;
            margin: 20px 0;
        }

        .highlight-box p {
            margin-bottom: 6px;
        }

        .highlight-box strong {
            color: #0f172a;
        }

        .sensitive-tag {
            display: inline-block;
            background: #fef3c7;
            color: #b45309;
            font-size: 12px;
            font-weight: 600;
            padding: 0 10px;
            border-radius: 20px;
            margin-right: 6px;
            letter-spacing: 0.3px;
        }

        .inline-code {
            background: #f1f5f9;
            padding: 0 8px;
            border-radius: 4px;
            font-family: monospace;
            font-size: 14px;
            color: #0f172a;
        }

        /* Contact Card */
        .contact-card {
            background: #f8fafc;
            border-radius: 12px;
            padding: 18px 22px;
            margin: 16px 0 8px;
            border: 1px solid #e9edf2;
        }

        .contact-card p {
            margin-bottom: 4px;
        }

        .contact-card .label {
            font-weight: 500;
            color: #0f172a;
            display: inline-block;
            min-width: 60px;
        }

        /* Footer */
        .footer-note {
            text-align: center;
            color: #94a3b8;
            font-size: 14px;
            margin-top: 40px;
            padding-top: 20px;
            border-top: 1px solid #e9edf2;
        }

        /* Responsive */
        @media (max-width: 600px) {
            .container {
                padding: 24px 18px;
            }

            h1 {
                font-size: 22px;
            }

            h2 {
                font-size: 18px;
            }

            .subhead {
                font-size: 13px;
            }

            .subhead span {
                display: block;
                margin: 4px 0;
            }
        }

        /* Numbered List Styling */
        .num-list {
            list-style: none;
            padding-left: 0;
            counter-reset: item;
        }

        .num-list>li {
            counter-increment: item;
            padding-left: 32px;
            position: relative;
            margin-bottom: 10px;
        }

        .num-list>li::before {
            content: counter(item) ".";
            position: absolute;
            left: 0;
            font-weight: 600;
            color: #0f172a;
        }

        .sub-list {
            list-style: none;
            padding-left: 28px;
            counter-reset: subitem;
        }

        .sub-list>li {
            counter-increment: subitem;
            padding-left: 28px;
            position: relative;
            margin-bottom: 6px;
        }

        .sub-list>li::before {
            content: counter(subitem, lower-alpha) ".";
            position: absolute;
            left: 0;
            color: #475569;
        }
    </style>
</head>
<body>

    <div class="container">

        <!-- Title Area -->
        <h1>ODance Privacy Policy</h1>
        <div class="subhead">
            <span>Updated: October 19, 2026</span>
            <span>Effective: October 19, 2026</span>
        </div>

        <!-- Operating Entity -->
        <div style="margin-bottom: 20px; padding: 12px 16px; background-color: #f8fafc; border-radius: 8px; border-left: 4px solid #3b82f6;">
            <p style="margin-bottom: 4px;"><strong>Operating Entity and Contact Information:</strong></p>
            <p style="margin-bottom: 0;">This Service is developed and operated by <strong>[Beijing OakCreek Technology Co., Ltd.]</strong> (hereinafter referred to as "we", "us", or "the Service"). The registered address is <strong>[Room 1468, 14th Floor, Building 1, No. 35 Jianguo Road, Chaoyang District, Beijing]</strong>, and the contact email is: <a href="mailto:support@oakcreektech.com" style="color: #3b82f6; text-decoration: none;">support@oakcreektech.com</a></p>
        </div>

        <!-- Introduction -->
        <p><strong>ODance</strong> (hereinafter referred to as the "Service") is a robot dance functional module embedded in the "BOOTER" APP. We highly value the importance of your personal information and will comply with the "Personal Information Protection Law of the People's Republic of China", "Cybersecurity Law of the People's Republic of China", "Data Security Law of the People's Republic of China", and other laws and regulations, and take corresponding security protection measures. This Privacy Policy explains how we collect, use, store, and share your information.</p>

        <p><strong>Version Division and Login Methods:</strong> The Service is divided into a Domestic Version and an Overseas Version according to the application interface language (for example, the Simplified Chinese interface is the Domestic Version, and a non-Simplified Chinese interface is the Overseas Version, subject to what is displayed on the login page). The Domestic Version supports registration/login via mobile phone number or email address; the Overseas Version supports registration/login via email address only. After switching the application language, the login methods and the scope of personal information collected will be adjusted accordingly; information collected before switching will still be processed in accordance with this Policy, and the Overseas Version will not additionally collect your mobile phone number.</p>

        <!-- ===== 1. Information We Collect ===== -->
        <h2>1. Information We Collect</h2>
        <p>When you use the Service, we may collect the following information:</p>

        <ul class="num-list">
            <li>
                <strong>Account Registration and Login Information (mobile phone number and/or email address)</strong>: The Domestic Version supports login via mobile phone number or email address; the Overseas Version supports login via email address only. When you choose to log in with a mobile phone number, we collect your mobile phone number; when you choose to log in with an email address, we collect your email address. The above information is used for registration, login, user identity verification, sending SMS/email verification codes, service notifications, and customer support. The Overseas Version does not provide mobile phone number login and does not collect your mobile phone number.
            </li>
            <li>
                <strong>Device Information</strong>: Device model, operating system version, unique device identifier (such as IDFA/Android ID), IP address, and network type. This information is used to ensure account security, optimize compatibility, and diagnose network issues.
            </li>
            <li>
                <strong>Bluetooth Information</strong>: Used to scan and connect your robot device to enable dance model delivery and control. Please note that on Android systems, scanning for Bluetooth devices requires you to grant "Location Permission"; this is a system-level requirement. We hereby solemnly promise that the Service will not collect, store, access, or infer any of your precise geographic location information through this permission. This permission is strictly used only to discover and connect nearby robot devices.
            </li>
            <li>
                <strong>Wi-Fi Information and MAC Address Explanation</strong><br>
                To discover nearby connectable Wi-Fi networks and assist you in completing robot network configuration and local area network device connection, we may, when you use Wi-Fi scanning or robot network configuration functions, obtain information about nearby Wi-Fi networks through the Android system Wi-Fi interface, including Wi-Fi name (SSID), Wi-Fi access point identifier (BSSID, which may be recognized as an access point MAC address), signal strength, and network connection status.<br><br>
                The above information is used only to display nearby available networks, identify the Wi-Fi selected by the user, complete robot network configuration, and establish local area network connections. Depending on the Android system version, scanning for nearby Wi-Fi networks may require you to authorize "Location Information" or "Nearby Devices" permissions; we collect this information only after you actively enter the relevant function and authorize it. You may refuse or turn off the relevant permissions, but doing so may prevent you from completing robot network configuration or discovering local area network devices, without affecting the use of other functions that do not rely on this permission.<br><br>
                <strong>Explanation regarding MAC Address</strong><br>
                The BSSID of Wi-Fi is typically used to identify a wireless access point, and its format may be the same as a MAC address. We do not actively obtain the real hardware MAC address of your phone's network card. To provide Wi-Fi scanning, robot network configuration, and one-click login services, the application or third-party SDKs may read the SSID and BSSID of Wi-Fi through system interfaces. For the Jiguang (Aurora) Authentication SDK, we have disabled mobile MAC address collection through its privacy collection control capability; however, the SDK may still read Wi-Fi SSID, BSSID, or network connection status when performing network environment assessments.
            </li>
            <li>
                <strong>Transaction Records</strong>: When you purchase dance model training services, we will record order information and payment status, but we will not store your bank card or third-party payment account information.
            </li>
            <li>
                <strong>Payment SDK Information</strong>: When you make a payment, the payment SDKs we integrate (iOS: Apple Pay; Android: WeChat Pay/Alipay) will collect your device model, order number, and payment timestamp to complete the transaction and conduct necessary payment environment security assessments based on their own risk control models. We do not obtain or store your complete bank account information, passwords, or CVV codes. After payment is completed, we only retain the order number and payment status.
            </li>
            <li>
                <strong>Photo Album/Storage</strong>: When you upload demonstration videos or save screenshots, we will read the photo album or local files. The demonstration videos you upload are used only for AI generation of dance models and will not be used for other purposes. The screenshots you save are stored on your local device. You may refuse access to the photo album/storage, but related functions (such as uploading videos) will not be available.
            </li>
            <li>
                <strong>Camera (Optional)</strong>: When you use the "Upload Video" function, you may choose to call the camera to directly record a demonstration video. The video is used only to generate dance models and will not be used for other purposes.
            </li>
        </ul>

        <!-- ===== Special Notice on Sensitive Personal Information ===== -->
        <h2>Special Notice on Sensitive Personal Information</h2>
        <p>We understand that information involved in some functions may constitute your sensitive personal information. In accordance with applicable laws, we will take strict protection measures when processing such information, and will only process it after obtaining your explicit consent when it is necessary to provide you with specific core functions:</p>

        <div class="highlight-box">
            <ul style="margin-bottom:0;">
                <li>
                    <span class="sensitive-tag">Sensitive</span> <strong>Personal Image Information</strong>: When you upload a demonstration video for generating a dance model, the video may contain personal information such as facial features and portraits of you or others. We process this information only to generate the dance model you have requested, will not use it for purposes other than identifying specific individuals, and will delete or anonymize the video file after the model generation is completed.
                </li>
            </ul>
        </div>

        <p>When you first use the upload function, we will separately request your explicit consent through pop-ups and other means. You may withdraw your consent at any time in your device settings or in the "Permission Management" section within the "BOOTER" APP. Withdrawal will not affect the validity of personal information processing activities already carried out based on your consent before the withdrawal.</p>

        <!-- ===== 2. How We Use Your Information ===== -->
        <h2>2. How We Use Your Information</h2>
        <ul class="num-list">
            <li>To provide, maintain, and optimize the core functions of the Service, including login, user uploading demonstration videos, AI training to generate dance models, delivering dance models to robots, and controlling their execution of dance movements.</li>
            <li>To verify the validity of paid services and prevent fraud.</li>
            <li>To send you necessary service notifications (such as model generation completion reminders).</li>
            <li>To improve our algorithms and service quality (using anonymized statistical data).</li>
        </ul>

        <!-- ===== 3. Information Sharing and Disclosure ===== -->
        <h2>3. Information Sharing and Disclosure</h2>
        <p>We will not share your personal information with any third party, except in the following circumstances:</p>
        <ul>
            <li>With your explicit consent;</li>
            <li>As required by laws and regulations or mandatory orders from judicial or administrative authorities;</li>
            <li>Sharing necessary information with our authorized partners (such as payment service providers, email/SMS sending service providers) (limited to what is necessary for payment, verification code sending, or service notifications, and requiring partners to comply with confidentiality obligations of the same level).</li>
        </ul>

        <div class="highlight-box" style="border-left-color:#8b5cf6;">
            <p><strong>Special Note:</strong></p>
            <ul style="margin-bottom:0;">
                <li>The demonstration videos you upload are used only to generate robot dance models. We will not use the videos for other purposes or provide them to third parties.</li>
            </ul>
        </div>

        <!-- ===== 4. Data Storage and Security ===== -->
        <h2>4. Data Storage and Security</h2>
        <ul class="num-list">
            <li>Your account information (mobile phone number and/or email address) and transaction records are stored on our servers (located in China).</li>
            <li>
                <strong>Storage Period:</strong> We will store your personal information for the period necessary to fulfill the processing purposes described in this Policy, or for the period required by laws and regulations. Specifically:
                <ul class="sub-list">
                    <li>Your account information (such as mobile phone number and/or email address) will be retained during the existence of your account and for 6 months after cancellation, to handle possible after-sales or disputes.</li>
                    <li>Your transaction records will be retained for at least 3 years to meet compliance requirements under the "E-commerce Law of the People's Republic of China" and other laws and regulations.</li>
                </ul>
            </li>
            <li>The demonstration videos you actively upload will be deleted from the server after completing the service you requested (such as model generation), unless you explicitly agree that we retain them after anonymization for algorithm optimization.</li>
            <li>After the purpose is achieved or the statutory storage period expires, we will delete or anonymize personal information.</li>
            <li>We use industry-standard encryption technology (TLS) to protect data transmission, and adopt access control, regular backups, and other measures to prevent data leakage. If your uploaded demonstration videos need to be uploaded to the server for AI training, they will be transmitted using TLS encryption.</li>
        </ul>

        <!-- ===== 5. Protection of Minors ===== -->
        <h2>5. Protection of Minors</h2>
        <p>Our services are primarily intended for adults. We fully recognize the importance of protecting the personal information of minors.</p>
        <ul>
            <li>
                <strong>Children under 14 years old:</strong> If you are under 14 years old, please read this Policy with your parents or other guardians, and only use our services and provide us with your personal information after obtaining the explicit consent of your guardian. If we discover that we have collected children's personal information without verifiable guardian consent, we will immediately delete the relevant data.
            </li>
            <li>
                <strong>Minors aged 14 to 18:</strong> If you are over 14 but under 18 years old, you should also obtain your guardian's consent or act under their guidance before using our services and providing personal information.
            </li>
        </ul>

        <!-- ===== 6. Changes to the Privacy Policy ===== -->
        <h2>6. Changes to the Privacy Policy</h2>
        <p>We may update this Policy.</p>
        <ul>
            <li>
                <strong>Material Changes:</strong> When changes to this Policy involve substantive changes in the purpose, method, or scope of our collection and use of personal information, or have a significant impact on your rights and interests, we will notify you through in-app pop-ups, emails, and other prominent means, and re-obtain your explicit consent.
            </li>
            <li>
                <strong>General Revisions:</strong> For other revisions that do not involve the above material changes (for example, changes in contact information, optimization, and clarification of wording), we will publicize them through in-app announcements, push notifications, etc. before the updated Policy takes effect. If you continue to use our services after the announcement, it is deemed that you have fully read, understood, and agreed to be bound by the revised Policy.
            </li>
        </ul>

        <!-- ===== 7. Contact Us ===== -->
        <h2>7. Contact Us</h2>
        <div class="contact-card">
            <p>Operating Entity: Beijing OakCreek Technology Co., Ltd.</p>
            <p>Registered Address: Room 1468, 14th Floor, Building 1, No. 35 Jianguo Road, Chaoyang District, Beijing</p>
            <p>Email: support@oakcreektech.com</p>
        </div>
        <p style="margin-top:8px;">Thank you for using ODance!</p>

        <!-- Footer -->
        <div class="footer-note">
            ODance · Provided by Oakay · Embedded in the “BOOTER” APP
        </div>

    </div>

</body>
</html>

    
`;
